import React, { Component } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'

import { Put, Post, Get } from 'utils/axios-token'
import { defaultFormVal } from './assets'
import Lang from 'Lang/General'

const HOC = (WrappedComponent) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      selectedSetting: defaultFormVal,
      subscribedPackage: true,
      translations: [],
      selectedEditTimeZone: null,
      selectedOperatingTimeZone: [],
      isTransLoaded: false
    }

    onChangeSettingHOC = (key, val, callback ) => this.setState({ [key]: val }, () => {
      callback && callback()
    })

    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success(success)
    requestError = error => toast.error(error)

    getSelectedSetting = () => Get(
      `/api/v1/dialogues/centers/support/${this.props.data.selectCenterReducer.selectedCenter.center.id}`,
      payload => this.setState({
        selectedSetting: payload,
        selectedOperatingTimeZone: payload.dialogue_operating_timezones || []
      }),
      () => {},
      this.load
    )

    createSetting = (dataToSubmit) => {
      Post(
        `/api/v1/dialogues/centers/${this.props.data.selectCenterReducer.selectedCenter.center.id}/settings`,
        dataToSubmit,
        () => this.createSettingSuccess(),
        this.createSettingError,
        this.load
      )
    }
    createSettingSuccess = () => {
      this.getSelectedSetting()
      this.requestSuccess(Lang['RECORD_UPDATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
    }
    createSettingError = error => this.requestError(error)

    updateSetting = (dataToSubmit) => {
      Put(
        `/api/v1/dialogues/centers/${this.props.data.selectCenterReducer.selectedCenter.center.id}/settings`,
        dataToSubmit,
        () => this.updateSettingSuccess(),
        this.updateSettingError,
        this.load
      )
    }
    updateSettingSuccess = () => {
      this.requestSuccess(Lang['RECORD_UPDATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
    }
    updateSettingError = error => this.requestError(error)

    getTranslation = () => Get(
      `/api/v1/sites/${ this.props.data.selectCenterReducer.selectedCenter.center.site.id }/page_translations`,
      this.getTranslationSuccess,
      this.getTranslationError,
      this.load
    )
    getTranslationSuccess = payload => {
      this.setState({
        translations: payload.data,
        isTransLoaded: true
      })
    }
    getTranslationError = () => {}
 
    render = () => {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          onLoadSettingHOC={this.state.loading}

          getSelectedSetting={this.getSelectedSetting}
          updateSetting={this.updateSetting}
          getTranslation={this.getTranslation}
          createSetting={this.createSetting}
          onChangeSettingHOC={this.onChangeSettingHOC}
        />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect(mapStateToProps)(WithHOC)
}

export default HOC